module.exports = __webpack_public_path__ + "img/sol_cap4.6ff4f8a0.png";